import script from "./WhatsAppReminderRules.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppReminderRules.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppReminderRules.vue?vue&type=style&index=0&id=56906fd1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56906fd1"]])

export default __exports__